/* --------------------------------------------------------------------------------------
   printSettings.component.component.js
   Copyright © 2019 Xerox Corporation. All Rights Reserved.

   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
   -------------------------------------------------------------------------------------
*/

export const printSettingsComponent = {
  template: require("./printSettings.html"),
  controllerAs: "vm",
  controller: class printSettingsController {
    /* @ngInject */
    constructor(
      commonService,
      printModuleService,
      printService,
      jobStatusService,
      sessionDataService,
      deviceInfoService,
      expensesService,
      ssoClientService,
      $state,
      $translate
    ) {
      this.commonService = commonService;
      this.printModuleService = printModuleService;
      this.printService = printService;
      this.jobStatusService = jobStatusService;
      this.sessionDataService = sessionDataService;
      this.deviceInfoService = deviceInfoService;
      this.expensesService = expensesService;
      this.$state = $state;
      this.$translate = $translate;
      this.ssoClientService = ssoClientService;
    }
    async $onInit() {
      this.buildLogoutConfirmButtons();
      this.screenSize = this.commonService.getScreenSize();
      this.deviceInfo = await this.deviceInfoService.get();
      this.isVersalink = this.deviceInfo.model.toLowerCase().includes("versa");
      this.expensesEnabled = this.expensesService.isEnabled(
        this.sessionDataService.user
      );
      this.printModuleService.setOptions();
      await this.printModuleService.setDefaults();
      this.commonService.updateView();
    }
    async ok() {
      //set current element selected
      const printOptions = {
        copies: this.printModuleService.copies,
        sides: this.printModuleService.twoSidedPrint,
        color: this.printModuleService.outputColor,
        staple: this.printModuleService.stapling ? "Staple" : "None",
      };

      this.printing = true;

      try {
        const printTokens = await Promise.all(
          this.sessionDataService.selectedFiles.map(async (file) => {
            return {
              guid: await this.generatePrintTicket(file),
              filename: file.DisplayName,
            };
          })
        );
        if (this.expensesEnabled && this.printModuleService.expense) {
          const printAllFiles = printTokens.map((token) =>
            this.printFile(token, printOptions)
          );
          const countAndExpense = this.getTotalPageCount(
            printTokens
          ).then((count) => this.sendExpenses(count));
          await Promise.all([...printAllFiles, countAndExpense]);
        } else {
          await Promise.all(
            printTokens.map((token) => this.printFile(token, printOptions))
          );
        }
      } catch (e) {
        this.error = true;
      }
      this.printing = false;
      await this.commonService.updateView();
    }
    async generatePrintTicket(file) {
      const tokenGuid = this.commonService.getNewGuid();
      await this.printModuleService.getPrintTicket(tokenGuid, file.ID);
      return tokenGuid;
    }
    async printFile(token, printOptions) {
      const printUrl = await this.printModuleService.getPrintUrl(token.guid);
      const jobId = await this.printService.SubmitPrint(
        printUrl,
        token.filename,
        printOptions
      );
      await this.jobStatusService.getPrintFinishedStatus(jobId);
    }
    async getTotalPageCount(printTokens) {
      const fileCounts = await Promise.all(
        printTokens.map((token) => this.getPageCount(token))
      );
      return fileCounts.reduce((prev, next) => prev + next);
    }
    async getPageCount(token) {
      const printPreview = await this.printModuleService.getPrintPreview(
        token.guid
      );
      return printPreview.PageCount;
    }
    sendExpenses(count) {
      return this.expensesService.sendExpenses(
        "print",
        this.sessionDataService.matter,
        count,
        this.sessionDataService.user
      );
    }
    cancel() {
      this.$state.go("main");
    }
    selectTwoSidedPrint(value) {
      this.printModuleService.twoSidedPrint = this.printModuleService.twoSidedPrintOptions[
        value.index
      ].key;
      this.printModuleService.twoSidedPrintText = value.label;
      this.commonService.updateView();
    }
    selectOutputColor(value) {
      this.printModuleService.outputColor = this.printModuleService.outputColorOptions[
        value.index
      ].key;
      this.printModuleService.outputColorText = value.label;
      this.commonService.updateView();
    }
    // logout button code
    async buildLogoutConfirmButtons() {
      this.confirmLogoutButtons = [
        {
          alertIcon: "glyphicon-close",
          text: await this.$translate("CANCEL"),
          click: () => this.cancelLogout(),
        },
        {
          alertIcon: "glyphicon-exit",
          text: await this.$translate("LOG_OUT"),
          click: () => this.logout(),
        },
      ];
    }
    showConfirmLogout() {
      this.confirmLogout = true;
    }
    errorClosed() {
      this.error = false;
      this.commonService.updateView();
    }
    cancelLogout() {
      this.confirmLogout = false;
      this.commonService.updateView();
    }
    logout() {
      this.ssoClientService.logout();
      this.$state.go("login");
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/print/components/printSettings.component.js